document.addEventListener("DOMContentLoaded", function () {
  const chatSections = document.querySelectorAll(".chat"); // Get all chat sections

  // Object to store timers for each section

  function checkVisibility() {
    chatSections.forEach((section) => {
      const rect = section.getBoundingClientRect();

      // Check if the section is in the viewport
      if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
        section.classList.add("chat-visible");
      } else {
        section.classList.remove("chat-visible");
      }
    });
  }

  // Initial check
  checkVisibility();

  // Add scroll event listener to check visibility as user scrolls
  window.addEventListener("scroll", checkVisibility);

  // Optionally, add resize event listener to handle viewport changes
  window.addEventListener("resize", checkVisibility);
});
